import {
  blueColor,
  darkColor,
  iconColor,
  lightBlueColor,
  secondaryRedColor,
} from "@/constants/colors";
import { inter } from "@/utils/fonts";
import { css } from "@emotion/react";
import clsx from "clsx";
import { ClassAttributes, forwardRef, InputHTMLAttributes } from "react";
import { Heading } from "../Typography";

export type InputProps = ClassAttributes<HTMLInputElement> &
  InputHTMLAttributes<HTMLInputElement> & {
    errorMessage?: string;
    fullWidth?: boolean;
  };

// eslint-disable-next-line react/display-name
const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ errorMessage, className, fullWidth, ...props }, ref) => {
    return (
      <div
        css={
          fullWidth
            ? css`
                width: 100%;
              `
            : undefined
        }
      >
        <input
          ref={ref}
          className={clsx(className, inter.className)}
          css={css`
            display: block;
            box-sizing: border-box;
            width: 100%;
            border: 2px solid ${errorMessage ? secondaryRedColor : blueColor};
            padding: 14px 24px;
            border-radius: 5px;
            font-weight: 500;
            font-size: 16px;
            line-height: 140%;
            color: ${darkColor};
            transition: border-color 0.2s ease-in-out;
            outline: none;
            ::placeholder {
              color: ${iconColor};
              font-weight: 500;
              opacity: 1;
            }
            &:focus {
              border-color: ${errorMessage
                ? secondaryRedColor
                : lightBlueColor};
            }
          `}
          {...props}
        />
        {errorMessage && (
          <Heading
            css={css`
              color: ${secondaryRedColor};
              font-weight: 350;
              font-size: 12px;
              line-height: 16px;
              margin-top: 4px;
            `}
          >
            {errorMessage}
          </Heading>
        )}
      </div>
    );
  }
);

export default Input;
